// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/light_baker.vertex.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'light_bakerVertexShader';
const shader = `#ifdef GL_ES
precision highp float;
#endif
attribute vec3 position;
attribute vec3 normal;
attribute vec2 uv;
attribute vec2 uv2;
uniform mat4 viewProjection;
varying vec2 vUV;
varying vec2 vUV2;
varying vec3 vPos;
varying vec3 vNormalW;
varying vec4 vWorldPos;
#include<instancesDeclaration>
void main(void) {
#include<instancesVertex>
gl_Position = vec4(uv2.x * 2.0 - 1.0, (-1.0 + uv2.y * 2.0), 0, 1.0);
vWorldPos = finalWorld * vec4(position, 1.0);
vPos = vec3(viewProjection * vWorldPos);
vNormalW = normalize(vec3(finalWorld * vec4(normal, 0.0)));
vUV = uv;
vUV2 = uv2;
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const light_bakerVertexShader = { name, shader };
//# sourceMappingURL=light_baker.vertex.js.map